/* eslint-disable @typescript-eslint/no-explicit-any */
import Select from "react-select";
import React from "react";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  Path,
} from "react-hook-form";
import selectStyle from "@/lib/select-style";
import RenderFieldError from "./RenderFieldError";
import makeAnimated from "react-select/animated";
import { useTranslations } from "next-intl";

const animatedComponents = makeAnimated();

type TCustomSelectWithHookForm<T extends FieldValues> = {
  control: Control<T>;
  options: { label: string; value: string }[];
  fieldName: Path<T>;
  errors: FieldErrors<T>;
  isMulti?: boolean;
  placeholder?: string;
};

const CustomSelectWithHookForm = <T extends FieldValues>({
  control,
  options,
  fieldName,
  errors,
  isMulti,
  placeholder = "Select an option",
  ...props
}: TCustomSelectWithHookForm<T>) => {
  const t = useTranslations();

  return (
    <div>
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            styles={selectStyle as any}
            options={options}
            components={animatedComponents}
            isMulti={isMulti}
            placeholder={t(placeholder)}
            isClearable
            value={options?.find((option) => option.value == field.value)}
            onChange={(option: any) => {
              if (isMulti) {
                field.onChange(
                  option?.map((option: { value: string }) => option.value)
                );
              } else {
                field.onChange(option?.value);
              }
            }}
            {...props}
          />
        )}
      />

      <RenderFieldError errors={errors} fieldName={fieldName} />
    </div>
  );
};

export default CustomSelectWithHookForm;
